module.exports = __webpack_public_path__ + "img/banner.cffe7e67.png";